export const selectCustomFields = state => state.additionalInformation.customFields;
export const selectSaveCustomFieldsResult = state => state.additionalInformation.status;
